import { render } from "./PaymentCardsView.vue?vue&type=template&id=03b8ee6c"
import script from "./PaymentCardsView.vue?vue&type=script&lang=js"
export * from "./PaymentCardsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__